import HtmlRenderer from './HtmlRenderer.vue';
import ActivityTable from './SimpleActivityTable.vue';
import Vue from 'vue';
export default Vue.extend({
    name: 'DynamicContent',
    props: {
        dynamicContent: {
            type: Object,
            required: true
        }
    },
    components: {
        HtmlRenderer,
        ActivityTable
    }
});
